import { render, staticRenderFns } from "./TranslationsCardPage.vue?vue&type=template&id=c21fc7ae"
import script from "./TranslationsCardPage.vue?vue&type=script&lang=js"
export * from "./TranslationsCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports